import React from "react";
import Image from "../Image";
import { medias } from "../../config/Resources";
import { Avatar } from "@mui/material";
import Text from "../Text";
import {
  //   ArrowDropDown,
  Chat,
  Notifications,
  Verified,
} from "@mui/icons-material";
import ExitToAppIcon from "@mui/icons-material/Logout";
import { HomeLayout } from "../../config/pageContent";
import classNames from "classnames";
import { Link, useLocation } from "react-router-dom";
import { Controls, Player } from "@lottiefiles/react-lottie-player";
import { useUserInfoStore } from "../../store/userinfo";
import WelcomeChat from "../../animations/WelcomeChat.json";
import { mediaResources } from "../../config/Constants";

const Homelayout = ({ children }: any) => {
  const location = useLocation();
  const { userInfo }: any = useUserInfoStore((state) => state);

  const handleLogout = () => {
    // Ask for user consent
    const consent = window.confirm("Are you sure you want to log out?");

    // If user consents, remove token from local storage and redirect
    if (consent) {
      localStorage.removeItem("token-student");
      // Redirect to the login page (replace with your login page route)
      window.location.href = "/";
    }
  };

  return (
    <div className="fixed flex w-screen h-screen overflow-auto bg-contain profileBackGround ">
      <div
        id="SideSection"
        className=" h-screen overflow-auto no-scrollbar w-[22%] flex justify-start items-center flex-col "
      >
        <div className="sticky top-0 z-[100] ">
          <Image
            src={medias.images.profilemainLogo}
            className="px-[45px]  top-0 desktop:pt-[60px] pt-[60px]"
            alt="PageLogo"
          />
          <div className="flex items-center gap-x-[10px]  py-[20px]   w-full  top-0  justify-center">
            <Avatar
              src={`${mediaResources}/Profile/DefaultAvatar.svg`}
              className="w-[60px] desktop:w-[40px] desktop:h-[40px] h-[60px]"
            />
            <div id="profile" className="sticky top-0">
              <Text className="text-[16px] desktop:text-[12px] font-[PlusJakartaSans-SemiBold] font-bold">
                {userInfo?.firstName} {userInfo?.middleName}{" "}
                {userInfo?.lastName} <Verified className="text-[#2771E7]" />
              </Text>
              <Text className="text-[13px] desktop:text-[10px]  font-medium ">
                Class XI Student
              </Text>
            </div>
          </div>
          <Text className="w-full px-[45px] !font-[PlusJakartaSans-Bold] text-[13px] desktop:text-[10px]  pb-[20px]  font-semibold ">
            Profile Completed{" "}
            <span className="px-2 ml-2 py-1 rounded-md text-white bg-[#2DB706] ">
              {" "}
              50%{" "}
            </span>
          </Text>
        </div>
        <div className="w-full ">
          {HomeLayout.map((items: any) => {
            return (
              <div className="relative px-[15px] ">
                <div
                  className={classNames(
                    location?.pathname.includes(items?.path)
                      ? "bg-[#2771E7] before:bg-[#2771E7] text-white"
                      : "text-black",
                    "font-bold flex px-[16px] gap-[18px]  items-center 3xl:py-[12px] py-[18px]  before:absolute before:h-full before:rounded-r-[16px] before  before:w-[7.8px] before:left-0  rounded-[16px] text-[18px]"
                  )}
                >
                  <Image
                    src={items?.Icons}
                    className="desktop:w-[20px]"
                    alt={`${items?.Icons}`}
                  />
                  <Text className="text-[16px] desktop:text-[12px] !font-[PlusJakartaSans-Bold]">
                    {items?.title}
                  </Text>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="w-[90%] py-[33px] overflow-auto no-scrollbar px-[28px] rounded-[41px] bg-white my-[15px] mr-[33px] ">
        <div className="flex items-center  gap-x-[20px] justify-between">
          <div
            id="introHeader "
            className="rounded-[20px] desktop:w-8/12 desktop:!px-[10px] desktop:!pl-[15px] w-8/12 shadow-[0px_5px_16px_rgba(0,0,0,0.06)] 3xl:px-[18px] px-[25px] flex items-center"
          >
            <Player
              autoplay
              speed={1.5}
              loop
              src={WelcomeChat}
              style={{ height: "100px", padding: 0, width: "100px" }}
            >
              <Controls
                visible={false}
                buttons={[
                  "play",
                  "repeat",
                  "frame",
                  "debug",
                  "snapshot",
                  "background",
                ]}
              />
            </Player>
            <Text className="text-[33px] desktop:!text-[17px] 3xl:text-[30px] font-quitery">
              Welcome, {userInfo?.firstName} {userInfo?.middleName}{" "}
              {userInfo?.lastName}
            </Text>
            <Text className="py-[15px] pr-[15px] desktop:py-[8px] desktop:pl-[30px] pl-[67px] bg-[#FFFABE] desktop:!text-[17px] text-[22px] font-quitery ml-auto rounded-[16px] w-fit">
              5000 UNICoins
            </Text>
          </div>
          <div>
            <Chat className="!text-[30px] 3xl:text-[35px]  desktop:!text-[25px]" />
          </div>
          <div>
            <Notifications className="!text-[30px] 3xl:text-[35px] desktop:!text-[25px]" />
          </div>
          <div className="flex items-center">
            <Avatar
              src={`${mediaResources}/Profile/DefaultAvatar.svg`}
              className="!rounded-lg desktop:w-[30px] desktop:h-[30px]"
            />
            <div className="mr-[10px] ml-[10px]">
              <Text className="font-bold desktop:!text-[12px] 3xl:text-[14px] font-[PlusJakartaSans-Bold]">
                {userInfo?.firstName} {userInfo?.lastName}
              </Text>
              <Text className="text-[14px] 3xl:text-[10px] desktop:!text-[10px]">
                Sub Admin (CM)
              </Text>
            </div>
            {/* <ArrowDropDown /> */}
            <ExitToAppIcon
              className="cursor-pointer"
              titleAccess="Logout"
              onClick={handleLogout}
            />
          </div>
        </div>
        {children}
      </div>
    </div>
  );
};

export default Homelayout;
